module.exports = __webpack_public_path__ + "static/media/Cowboy Bandit800_4c.dea94367.svg";